<div class="sign-in-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div
                class="daxa-form ml-auto mr-auto border-radius bg-white"
                [class.card-borderd-theme]="themeService.isCardBorder()"
                [class.component-dark-theme]="themeService.isDark()"
                [class.rtl-enabled]="themeService.isRTLEnabled()"
            >
                <div class="title text-center">
                    <h3>
                        Lockers
                    </h3>

                </div>
                <form [formGroup]="authForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <label class="main-label d-block lh-1 text-black">
                            Username
                        </label>
                        <mat-form-field>
                            <mat-label>
                                Inserisci il tuo username
                            </mat-label>
                            <input autofocus matInput type="email" id="username" formControlName="username">
                        </mat-form-field>
                        <div class="error text-danger" *ngIf="authForm.get('username')!.hasError('required')">
                            Username obbligatorio
                        </div>

                    </div>
                    <div class="form-group">
                        <label class="main-label d-block lh-1 text-black">
                            Password
                        </label>
                        <mat-form-field>
                            <mat-label>
                                Inserisci la tua password
                            </mat-label>
                            <input autofocus matInput [type]="hide ? 'password' : 'text'" id="password" formControlName="password">
                            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                <span class="material-symbols-outlined">
                                    {{hide ? 'visibility_off' : 'visibility'}}
                                </span>
                            </button>
                        </mat-form-field>
                        <div class="error text-danger" *ngIf="authForm.get('password')!.hasError('required')">
                            Password obbligatoria.
                        </div>

                    </div>
                    <div class="info d-flex justify-content-between align-items-center">
                        <mat-checkbox [checked]="rememberMe" (change)="toggleRememberMe($event.checked)">
                            Ricordami
                        </mat-checkbox>
                    </div>
                    <button mat-button class="btn" type="submit" [disabled]="authForm.invalid">
                        Accedi
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>
